import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

const state = {
  username: null,
  token: null,
  unicamp_id: 1,
  userData: {
    given_name: '',
    family_name: '',
    email: '',
    preferred_username: null,
    kc_uuid: null,  // campo unico do keycloak
  },
  isAuthenticated: null,
  logout: null,
  resourceAccess: [],
  process: {},
  type: null,
  processId: null,
  downloadPdf: false,
  activeProcesses: {},
};

const mutations = {
  setIsAuthenticated(state, newAuthenticated) {
    state.isAuthenticated = newAuthenticated;
  },
  setUserData(state, newUserData) {
    // Atualiza dados do usuário
    state.userData = { ...state.userData, ...newUserData };
    if (newUserData.sub) {
      state.userData.kc_uuid = newUserData.sub;
    }
  },
  setUsername(state, newUsername) {
    state.username = newUsername;
  },
  setToken(state, newToken) {
    state.token = newToken;
  },
  setLogout(state, logoutFunction) {
    state.logout = logoutFunction;
  },
  setResourceAccess(state, newResourceAccess) {
    state.resourceAccess = newResourceAccess;
  },
  setProcess(state, newProcess) {
    state.process = newProcess;
  },
  setKcUuid(state, kcUuid) {
    state.userData.kc_uuid = kcUuid;
  },
  setType(state, type) {
    state.type = type;
  },
  setProcessId(state, processId) {
    state.processId = processId;
  },
  setDownloadPdf(state, downloadPdf) {
    state.downloadPdf = downloadPdf;
  },
  setActiveProcesses(state, activeProcesses) {
    state.activeProcesses = activeProcesses;
  },
};

const actions = {
  async logout({ commit, state }) {
    if (typeof state.logout === 'function') { 
      state.logout();
    }
    commit('setUserData', { given_name: '', family_name: '', email: '', preferred_username: null, kc_uuid: null }); 
    commit('setToken', "");
    commit('setIsAuthenticated', false);
  },
  updateUsername({ commit }, newUsername) {
    commit('setUsername', newUsername);
  },
  updateToken({ commit }, newToken) {
    commit('setToken', newToken);
  },
  updateProcess({ commit }, newProcess) {
    commit('setProcess', newProcess);
  },
  updateResourceAccess({ commit }, newResourceAccess) {
    commit('setResourceAccess', newResourceAccess);
  },
  updateKcUsername({ commit }, kcUsername) { 
    commit('setKcUsername', kcUsername);
  },
  updateProcessId({ commit }, newProcessId) {
    commit('setProcessId', newProcessId);
  },
  updateType({ commit }, newType) {
    commit('setType', newType);
  },
  updateActiveProcesses({ commit }, newActiveProcesses) {
    commit('setActiveProcesses', newActiveProcesses);
  },
};

const getters = {
  getKeycloak: state => state.keycloak, 
  getResourceAccess: state => state.resourceAccess,
  getUnicamp_id: state => state.unicamp_id,
  getUsername: state => state.username,
  getToken: state => state.token,
  getUserData: state => state.userData,
  getKcUuid: state => state.userData.kc_uuid, 
  getIsAuthenticated: state => state.isAuthenticated,
  getProcess: state => state.process,
  getType: state => state.type,
  getProcessId: state => state.processId,
  getActiveProcesses: state => state.activeProcesses,
};

export default createStore({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    createPersistedState({
      paths: [
        'activeProcesses'
      ]
    })
  ]
});
